const AUTH_BASE_URL = process.env.REACT_APP_AUTH_BASE_URL;
const VERSION = process.env.REACT_APP_VERSION;

let refreshPromise = null; // Global variable to track refresh token requests

export const refreshAccessToken = async () => {
    if (!refreshPromise) {
        refreshPromise = (async () => {
            try {
                const refreshToken = localStorage.getItem("refreshToken");
                if (!refreshToken) throw new Error("No refresh token available");

                const response = await fetch(`${AUTH_BASE_URL}/${VERSION}/user/token/refresh`, {
                    method: "GET",
                    headers: { Authorization: `Bearer ${refreshToken}` },
                });

                const data = await response.json();

                if (data.response_code === 200) {
                    localStorage.setItem("accessToken", data.response.accessToken);
                    localStorage.setItem("refreshToken", data.response.refreshToken);
                    return data.response.accessToken; // Return new access token
                } else {
                    throw new Error("Failed to refresh token");
                }
            } catch (error) {
                console.error("Token Refresh Error:", error);
                handleLogout();
                return null;
            } finally {
                refreshPromise = null; // Reset after completion
            }
        })();
    }

    return refreshPromise; // Return the same promise for all requests
};

export const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("username");
    const currentPath = window.location.pathname + window.location.search;
    console.log(currentPath)
    if (currentPath !== "/" && currentPath !== "/otp" && currentPath !== "/dashboard") {
        sessionStorage.setItem("redirectPath", currentPath);
    }
    window.location.href = "/"; // Redirect to login page
};

export const apiFetch = async (endpoint, method, body, headers) => {
    try {
        let accessToken = localStorage.getItem("accessToken");

        let options = {
            method,
            headers: {
                ...(headers || {}),
                Authorization: `Bearer ${accessToken}`,
                "app-version": "1.0.0"
            },
        };

        if (body) {
            options.body = body;
        }

        let response = await fetch(endpoint, options);
        let data = await response.json();
        console.log(data)

        if (data.response_code === 200) {
            return data; // Return actual data
        }

        if (data.response_code === 412) {
            // Throw a custom error object that can be detected later
            const customError = new Error("AccessDenied");
            customError.code = 412;
            throw customError;
        }

        if (data.response_code === 401 || data.response_code === 403) {
            console.warn("Access token expired, attempting refresh...");

            const newAccessToken = await refreshAccessToken();

            if (newAccessToken) {
                console.log("Token successfully refreshed");

                // Retry the original request with the new token
                options.headers.Authorization = `Bearer ${newAccessToken}`;
                response = await fetch(endpoint, options);
                data = await response.json();

                console.log(data)

                // if (data.response_code === 200) {
                //     return data.response;
                // }

                if (data.response_code === 412) {
                    const customError = new Error("AccessDenied");
                    customError.code = 412;
                    throw customError;
                }

                if (data.response_code === 406) {
                    const customError = new Error("AccountBlocked");
                    customError.code = 406;
                    throw customError;
                }

                return data;
            }

            handleLogout(); // If refresh failed, log out
            return null;
        }

        if(data.response_code === 406){
          const customError = new Error("AccountBlocked");
          customError.code = 406;
          throw customError;
        }else if(data.response_code === 404){
          const customError = new Error("NotFound");
          customError.code = 404;
          throw customError;
        }else if(data.response_code === 400){
          const customError = new Error(data.message);
          customError.code = 400;
          throw customError;
        }else{
          throw new Error(data.message || "API Error");
        }
    } catch (error) {
        console.error("API Fetch Error:", error);
        throw error;
    }
};